module.exports = __webpack_public_path__ + "img/sidebar-1.cb55b0d6.jpg";